// ml.js - wrapper around worker.js
let worker = null;
let ready = false;

export function initML() {
  if (!worker) {
    worker = new Worker(new URL('./worker.js', import.meta.url), {
      type: 'module'
    });
    
    worker.postMessage({ type: 'load' });
    
    worker.addEventListener('message', (e) => {
      if (e.data.status === 'ready') ready = true;
    });
  }
}

export function generateEmbedding(text) {
  if (!worker || !ready) return Promise.resolve(null);
  
  return new Promise((resolve) => {
    const handler = (e) => {
      if (e.data.status === 'complete' && e.data.text === text) {
        worker.removeEventListener('message', handler);
        resolve(e.data.embedding);
      } else if (e.data.status === 'error') {
        worker.removeEventListener('message', handler);
        resolve(null);
      }
    };
    worker.addEventListener('message', handler);
    worker.postMessage({ type: 'embed', text });
  });
}
